import { render, staticRenderFns } from "./newsGet.vue?vue&type=template&id=743aba26&scoped=true&"
import script from "./newsGet.vue?vue&type=script&lang=js&"
export * from "./newsGet.vue?vue&type=script&lang=js&"
import style0 from "./newsGet.vue?vue&type=style&index=0&id=743aba26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743aba26",
  null
  
)

export default component.exports